import Vue from "vue"
import Vuex from "vuex"

// Persistant Store
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

import App from "./common/App"
import AuthService from "./common/AuthService"
import GraphQL from "./common/GraphQL"
import SessionManager from "./common/SessionManager"

import global from "./modules/global"
import maintenance from "./modules/maintenance"
import plots from "./modules/plots"
import reports from "./modules/reports"

const persistState = createPersistedState({
  paths: ["GraphQL", "AuthService", "SessionManager"],
})

export default new Vuex.Store({
  modules: {
    App,
    AuthService,
    GraphQL,
    global,
    maintenance,
    plots,
    SessionManager,
    reports,
  },
  plugins: [persistState],
})
